import { Injectable } from '@angular/core';
@Injectable({
    providedIn: 'root',
})
export class ConfigurationService {
    APIURL: string;
    auth0Domain: string;
    auth0ClientId: string;
    auth0Audience: string;
    HasSimulator: boolean;

    // do not use any angular infrastructure here
    async load(): Promise<ConfigurationService> {
        return new Promise((resolve, reject) => {
            var that = this;

            var xmlHttpRequest = new XMLHttpRequest();
            xmlHttpRequest.onreadystatechange = function () {
                if (this.readyState === 4) {
                    if (this.status / 100 === 2) {
                        var configJSON = JSON.parse(this.responseText);
                        that.APIURL = configJSON.APIURL;
                        that.auth0Domain = configJSON.Auth0__Domain;
                        that.auth0ClientId = configJSON.Auth0__ClientId;
                        that.auth0Audience = configJSON.Auth0__Audience;
                        that.HasSimulator = configJSON.HasSimulator;
                        resolve(that);
                    } else {
                        reject('Could not load config.json');
                    }
                }
            };

            xmlHttpRequest.open('GET', './assets/config.json', true);
            xmlHttpRequest.send();
        });
    }
}
